import defaultAvatarImg from "../assets/avatar-default.png";

export const DEFAULT_USER_AVATAR = defaultAvatarImg;

function normalizeAvatarOption(item) {
  if (!item || typeof item !== "object") return null;
  const id = Number(item.id);
  const url = `${item.url || item.avatarUrl || ""}`.trim();
  if (!Number.isFinite(id) || id <= 0) return null;
  return { id, url };
}

export function normalizeAvatarList(raw) {
  const list = Array.isArray(raw) ? raw : raw?.list || raw?.data || [];
  return list.map(normalizeAvatarOption).filter(Boolean);
}

/** 用户头像 URL：已设置 url 或 avatarId 对应预设图；否则本地默认图 */
export function resolveUserAvatarUrl(userInfo, avatarOptions = []) {
  const fromUser = `${userInfo?.avatarUrl || userInfo?.headImgUrl || ""}`.trim();
  if (fromUser) return fromUser;

  const avatarId = Number(userInfo?.avatarId || 0);
  if (avatarId > 0) {
    const options = normalizeAvatarList(avatarOptions);
    const byUserId = options.find((a) => a.id === avatarId && a.url);
    if (byUserId?.url) return byUserId.url;
  }

  return DEFAULT_USER_AVATAR;
}

export function resolveUserDisplayName(userInfo) {
  const nickname = `${userInfo?.nickname || userInfo?.nickName || ""}`.trim();
  if (nickname) return nickname;
  return `${userInfo?.secretUserName || userInfo?.userName || ""}`.trim() || "User";
}

export function resolveUserVipLabel(userInfo) {
  return `${userInfo?.userVipLevelName || ""}`.trim();
}

export function resolveUserEmailLabel(userInfo) {
  const secret = `${userInfo?.secretUserName || ""}`.trim();
  if (secret && secret.includes("@")) return secret;
  const email = `${userInfo?.email || ""}`.trim();
  if (!email) return secret || "";
  if (/@/.test(email)) {
    return email.replace(/(\w{2}).*(\w{1})@(.*)/, "$1***@$3");
  }
  return email;
}
